// extracted by mini-css-extract-plugin
export default {"address":"style_address__h3Czx","address1":"style_address1__Ip0HX","address2":"style_address2__Dt1Pv","city":"style_city__npJS-","zip":"style_zip__ZNw6h"};